export default "__VITE_ASSET__DGdI3hCX__"